export const endpoint = {
  riskReport: 'riskReport',
  drilldown: (id: number) =>  `riskReport/${id}/drilldown`,
  report: 'report',
  reportCategory: 'report/options'
};

export enum RiskMatrixTypes {
  Type3 = 3,
  Type4 = 4
}

export const riskReportTranslation = {
  risk_matrix_not_supported: 9279,
  attribute_show_loss_potential: 9298,
  attribute_show_residual_loss_potential: 9299,
  attribute_xAxis_labels_enabled: 8030,
  attribute_yAxis_labels_enabled: 8029,
  toggle_info_description: 7759,
  toggle_info_subtitle: 7760,
  toggle_info_title: 7761,
  search_no_hits: 7548,
  warning_select_residual_or_loss_potential: 9301,
  drill_down_to_info: 9314
};
